export abstract class BaseModel {
  id?: number;

  static setPropValueType<T>(data: any, property: string, fromJsonMethod: (jsonData: any) => T): void {
    if (data[property]) {
      data[property] = fromJsonMethod(data[property]);
    }
  }

  static setPropListType<T>(data: any, property: string, fromJsonMethod: (jsonData: any) => T): void {
    data[property] = data[property].map((item) => fromJsonMethod(item));
  }

  private doGetObjMapFields(obj: BaseModel, ownerField: string): Object {
    const objMapField = obj.getMapFields();
    Object.keys(objMapField).forEach(k => {
      Object.defineProperty(objMapField, `${ownerField}.${k}`,
        Object.getOwnPropertyDescriptor(objMapField, k));
      delete objMapField[k];
    });
    return objMapField;
  }

  getDefaultMapFields(customMapFields: Object): object {
    let defMap = {};
    Object.keys(this).forEach(fieldName => {
      const field = this[fieldName];

      if (field instanceof Array) {
        field.forEach(arrayItem => {
          if (arrayItem instanceof BaseModel) {
            defMap = Object.assign(defMap, this.doGetObjMapFields(arrayItem, fieldName));
          }
        })
      }

      if (field instanceof BaseModel) {
        defMap = Object.assign(defMap, this.doGetObjMapFields(field, fieldName));
      } else {
        defMap[fieldName] = fieldName
      }
    });
    return {...defMap, ...customMapFields};
  }

  abstract getMapFields(): Object;
}
